angular.module("dx.webapp.referral", [
	"digiexam.services",
	"dx.webapp.session",
]);
